import { Link } from 'react-router-dom';

export default function BookingCta() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="border-y border-background-300 py-8 md:py-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div>
            <div className="text-[11px] uppercase tracking-[0.24em] text-accent-700 mb-3">
              <span className="inline-block w-6 h-px bg-accent-500 align-middle mr-3" />
              Ready when you are
            </div>
            <h2 className="font-heading text-foreground-950 text-3xl md:text-5xl leading-[1.05]">
              Book your Emerald Coast stay.
            </h2>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
            <Link
              to="/vacation-search-results"
              className="inline-flex items-center justify-center gap-2 bg-foreground-950 text-background-50 px-6 py-3 rounded-lg text-sm cursor-pointer hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              View All Properties
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="#concierge"
              className="inline-flex items-center justify-center gap-2 border border-[#DED0BE] bg-[#EFE4D6] text-foreground-900 px-6 py-3 rounded-lg text-sm cursor-pointer hover:bg-[#E9DCCB] hover:border-[#B99F87] transition-colors whitespace-nowrap"
            >
              Ask the Insider
              <i className="ri-arrow-right-up-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
